import React from "react";

import {ReactComponent as PopularIcon} from "../images/icons/popularGames.svg";
import {ReactComponent as Favorite} from "../images/icons/favorite.svg";

import img1 from "../images/cards/popular/card-1.jpg";
import img2 from "../images/cards/popular/card-2.jpg";
import img3 from "../images/cards/popular/card-3.jpg";
import img4 from "../images/cards/popular/card-4.jpg";
import img5 from "../images/cards/popular/card-5.jpg";
import img6 from "../images/cards/popular/card-6.jpg";
import img7 from "../images/cards/popular/card-7.jpg";
import img8 from "../images/cards/popular/card-8.jpg";

const PopularGamesDB = [
  {
    title: 'Popular Games',
    icon: <PopularIcon/>,
    card: [
      {
        image: img1,
        name: 'coinfest',
        icon: <Favorite/>
      },
      {
        image: img2,
        name: 'dice',
        icon: <Favorite/>
      },

      {
        image: img3,
        name: 'DragonKings',
        icon: <Favorite/>
      },
      {
        image: img4,
        name: 'FruitMillion',
        icon: <Favorite/>
      },
      {
        image: img5,
        name: 'Slot 777',
        icon: <Favorite/>
      },
      {
        image: img6,
        name: 'CloverBonanza',
        icon: <Favorite/>
      },
      {
        image: img7,
        name: 'Gunspinner',
        icon: <Favorite/>
      },
      {
        image: img8,
        name: 'SmackMe',
        icon: <Favorite/>
      },
      {
        image: img1,
        name: 'coinfest',
        icon: <Favorite/>
      },
      {
        image: img2,
        name: 'dice',
        icon: <Favorite/>
      },

      {
        image: img3,
        name: 'DragonKings',
        icon: <Favorite/>
      },
      {
        image: img4,
        name: 'FruitMillion',
        icon: <Favorite/>
      },
      {
        image: img5,
        name: 'Slot 777',
        icon: <Favorite/>
      },
      {
        image: img6,
        name: 'CloverBonanza',
        icon: <Favorite/>
      },
      {
        image: img7,
        name: 'Gunspinner',
        icon: <Favorite/>
      },
      {
        image: img8,
        name: 'SmackMe',
        icon: <Favorite/>
      }, {
        image: img1,
        name: 'coinfest',
        icon: <Favorite/>
      },
      {
        image: img2,
        name: 'dice',
        icon: <Favorite/>
      },

      {
        image: img3,
        name: 'DragonKings',
        icon: <Favorite/>
      },
      {
        image: img4,
        name: 'FruitMillion',
        icon: <Favorite/>
      },
      {
        image: img5,
        name: 'Slot 777',
        icon: <Favorite/>
      },
      {
        image: img6,
        name: 'CloverBonanza',
        icon: <Favorite/>
      },
      {
        image: img7,
        name: 'Gunspinner',
        icon: <Favorite/>
      },
      {
        image: img8,
        name: 'SmackMe',
        icon: <Favorite/>
      },
      {
        image: img1,
        name: 'coinfest',
        icon: <Favorite/>
      },
      {
        image: img2,
        name: 'dice',
        icon: <Favorite/>
      },

      {
        image: img3,
        name: 'DragonKings',
        icon: <Favorite/>
      },
      {
        image: img4,
        name: 'FruitMillion',
        icon: <Favorite/>
      },
      {
        image: img5,
        name: 'Slot 777',
        icon: <Favorite/>
      },
      {
        image: img6,
        name: 'CloverBonanza',
        icon: <Favorite/>
      },
      {
        image: img7,
        name: 'Gunspinner',
        icon: <Favorite/>
      },
      {
        image: img8,
        name: 'SmackMe',
        icon: <Favorite/>
      },
      {
        image: img1,
        name: 'coinfest',
        icon: <Favorite/>
      },
      {
        image: img2,
        name: 'dice',
        icon: <Favorite/>
      },

      {
        image: img3,
        name: 'DragonKings',
        icon: <Favorite/>
      },
      {
        image: img4,
        name: 'FruitMillion',
        icon: <Favorite/>
      },
      {
        image: img5,
        name: 'Slot 777',
        icon: <Favorite/>
      },
      {
        image: img6,
        name: 'CloverBonanza',
        icon: <Favorite/>
      },
      {
        image: img7,
        name: 'Gunspinner',
        icon: <Favorite/>
      },
      {
        image: img8,
        name: 'SmackMe',
        icon: <Favorite/>
      },
      {
        image: img1,
        name: 'coinfest',
        icon: <Favorite/>
      },
      {
        image: img2,
        name: 'dice',
        icon: <Favorite/>
      },

      {
        image: img3,
        name: 'DragonKings',
        icon: <Favorite/>
      },
      {
        image: img4,
        name: 'FruitMillion',
        icon: <Favorite/>
      },
      {
        image: img5,
        name: 'Slot 777',
        icon: <Favorite/>
      },
      {
        image: img6,
        name: 'CloverBonanza',
        icon: <Favorite/>
      },
      {
        image: img7,
        name: 'Gunspinner',
        icon: <Favorite/>
      },
      {
        image: img8,
        name: 'SmackMe',
        icon: <Favorite/>
      },

      // {
      //   image: img1,
      //   name: 'coinfest',
      //   icon: <Favorite/>
      // },
      // {
      //   image: img2,
      //   name: 'dice',
      //   icon: <Favorite/>
      // },
    ]
  }
]
export default PopularGamesDB